import clsx from "clsx";
import React from "react";
import { ActionsMenu } from "../../../../common/components/ActionsMenu";
import { ConditionalWrapper } from "../../../../common/components/ConditionalWrapper";
import { useDropdown } from "../../../../common/components/dropdown/useDropdown";
import useModal from "../../../../common/components/modals/useModal";
import { useAccessWindowSize } from "../../../../common/layout/useAccessWindowSize";
import { getCriterionModalId } from "../../utils";
import useDropdownPosition from "../useDropdownPosition";
import { criteriaElementsType } from "../../../../common/types/search/search";

interface CompositeDropdownProps {
	label: string;
	criteria?: criteriaElementsType;
	quickSearch?: boolean;
}

export function CompositeDropdown({
	label,
	criteria,
	quickSearch = false,
}: CompositeDropdownProps) {
	const { dropdownRef, dropdownIsOpened, onDropdownToggle } = useDropdown();
	const { isMobile } = useAccessWindowSize();
	const { onOpenModal, onCloseModal } = useModal();
	const { isDropdownBelowViewport, isDropdownHidden } = useDropdownPosition(
		dropdownRef,
		dropdownIsOpened,
		quickSearch,
	);
	const criterionKey = `${label}_composite_criterion`;
	const modalId = getCriterionModalId(criterionKey);

	const handleDropdownToggleClick = () => {
		onDropdownToggle();
		onOpenModal(modalId);
	};

	const handleSaveInput = () => {
		onDropdownToggle();
		onCloseModal(modalId);
	};

	return (
		<div
			ref={dropdownRef}
			className="criterion composite-criterion dropdown"
		>
			<button
				type="button"
				onClick={handleDropdownToggleClick}
				className={`dropdown-toggle`}
				aria-expanded={dropdownIsOpened}
			>
				{label}
			</button>

			<ConditionalWrapper
				condition={isMobile}
				wrapper={(children) => (
					<ActionsMenu
						id={modalId}
						title={label}
						onClose={handleSaveInput}
					>
						{children}
					</ActionsMenu>
				)}
			>
				<div
					className={clsx("dropdown-menu", {
						"dropdown-menu--opened": dropdownIsOpened,
						"dropdown-menu--inverted-y": isDropdownBelowViewport,
						"dropdown-menu--hidden": isDropdownHidden,
					})}
				>
					<div className="dropdown-items-wrapper">
						{criteria.map((item, index) => (
							<React.Fragment key={index}>{item}</React.Fragment>
						))}
					</div>
				</div>
			</ConditionalWrapper>
		</div>
	);
}
